export default {
  slots: {
    identity: {
      label: 'Documento de identidad',
      hint: 'Carné de identidad, pasaporte o permiso de residencia, frente y reverso. Aquí también van las identificaciones de tus socios.',
    },
    trade_registration: {
      label: 'Registro comercial (Gewerbeanmeldung)',
      hint: 'El registro comercial que recibiste de la oficina de comercio.',
    },
    commercial_register_extract: {
      label: 'Extracto del registro mercantil (Handelsregisterauszug)',
      hint: 'Un extracto actual del registro mercantil, si tu negocio está inscrito allí.',
    },
    bank_statement: {
      label: 'Extracto bancario (Kontoauszug)',
      hint: 'Un extracto reciente de tu cuenta comercial que muestre el titular de la cuenta y el IBAN.',
    },
    shareholder_list: {
      label: 'Lista de socios (Gesellschafterliste)',
      hint: 'La lista actual de socios.',
      hint_gbr: 'Tu contrato de sociedad (Gesellschaftsvertrag) o una lista de todos los socios.',
    },
    tax_number: {
      label: 'Número de identificación fiscal o NIF-IVA (Steuernummer oder USt-IdNr.)',
      hint: 'Una carta de la oficina de impuestos que muestre tu número fiscal, o la confirmación de tu NIF-IVA.',
    },
  },
  tags: {
    required: 'Obligatorio',
    optional: 'Opcional',
    missing: 'Falta',
  },
  kinds: {
    passport: 'Pasaporte',
    driver_license: 'Licencia de conducir',
    id_card: 'Carné de identidad',
    residence_permit: 'Permiso de residencia',
  },
  holders: {
    owner: 'Propietario',
    partner: 'Socio: {{name}}',
  },
  file: {
    with_back: 'Frente y reverso',
    uploaded_at: 'Subido el {{date}}',
    expires_at: 'Válido hasta el {{date}}',
  },
  errors: {
    load: 'No se pudieron cargar los documentos.',
  },
  empty: 'Aún no hay archivo',
  buttons: {
    add: 'Agregar archivo',
    replace: 'Reemplazar',
    remove: 'Eliminar',
    retry: 'Inténtalo de nuevo',
  },
  remove_confirm: {
    title: '¿Eliminar este archivo?',
    description: 'Usa esto para un archivo que subiste por error.',
    ok: 'Eliminar',
    cancel: 'Cancelar',
  },
  toasts: {
    remove_success: 'Archivo eliminado',
    remove_error: 'No se pudo eliminar el archivo. Inténtalo de nuevo.',
  },
};
